import Vue from 'vue'
import App from './App'
import store from './store/store'

import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons)



import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'




Vue.config.productionTip = false;

var access_token = localStorage.getItem('token');
if( access_token ) {
    //axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`
}


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    created: function () {
        //console.log('ruszam');
        localStorage.removeItem( 'acts' );
    }
})



// WEBPACK FOOTER //
// ./src/main.js